"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayerManager = void 0;
var React = require("react");
var dialog_context_1 = require("./dialog-context");
var layer_context_1 = require("./layer-context");
var LayerManager = function (_a) {
    var children = _a.children;
    var _b = __read(React.useReducer(layer_context_1.layerManagerReducer, []), 2), layers = _b[0], dispatchLayerAction = _b[1];
    var appBaseRef = React.useRef();
    var layerRootRef = React.useRef();
    var appLayerClass = "app-layer-base".concat(layers.length === 0 ? '--active' : '');
    return (React.createElement(layer_context_1.LayerProvider, { value: { layers: layers, dispatchLayerAction: dispatchLayerAction, appBaseRef: appBaseRef, layerRootRef: layerRootRef } },
        React.createElement(dialog_context_1.DialogProvider, null,
            React.createElement("div", { id: "app-layer-manager", ref: layerRootRef },
                React.createElement("div", { id: "app-layer-base", "aria-hidden": Boolean(layers.length), className: appLayerClass, ref: appBaseRef }, children)))));
};
exports.LayerManager = LayerManager;
//# sourceMappingURL=layer-manager.js.map